// extracted by mini-css-extract-plugin
export default {"commentsCountButton":"n3W9C"};